import {
    buildRecordLifecyclePagedListActions,
    type RecordLifecycleConfirmKind,
} from "../../utils/navigation/recordLifecycleActions";
import { EntityLabels } from "../../utils/navigation/pageTitles";

export type TcAdminConfirmKind = RecordLifecycleConfirmKind;

export function formatTcToastLabel(code: string | undefined): string {
    const t = typeof code === "string" ? code.trim() : "";
    return t.length > 0 ? t : EntityLabels.technicalCompetenceScheme;
}

export function getTcAdminActionSuccessMessage(
    kind: TcAdminConfirmKind,
    code: string | undefined
): string {
    const label = formatTcToastLabel(code);
    const successByKind: Record<TcAdminConfirmKind, string> = {
        disable: `${label} disabled successfully!`,
        enable: `${label} enabled successfully!`,
        softDelete: `${label} deleted successfully!`,
        restore: `${label} restored successfully!`,
    };
    return successByKind[kind];
}

type TcRow = { id: string; code: string };

export const buildTcAdminPagedListActions = (openConfirm: (kind: TcAdminConfirmKind, item: TcRow) => void) =>
    buildRecordLifecyclePagedListActions<TcRow>(openConfirm, { activeMember: "isActive" });
